import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/attractions/useAttractionQueryKeys.ts
var t = e("attractions", { byArea: (e, t, n, r) => [
	"by-area",
	e,
	`${t},${n}`,
	r ?? "all"
] });
//#endregion
export { t as attractionQueryKeys };
